<nz-result class="flex flex-col items-center justify-center" nzStatus="404" nzTitle="404" nzSubTitle="Sorry, the page you visited does not exist.">
    <div nz-result-extra>
        <button nz-button nzType="primary" (click)="_location.back()">Back</button>
    </div>
</nz-result>